var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',[_c('v-spacer'),_c('p',[_vm._v("Need help? Contact us at "),_c('a',{attrs:{"href":"mailto:eclass@ualberta.ca"}},[_vm._v("eclass@ualberta.ca")]),_vm._v(" or 780-492-9372")]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }